module.exports = __webpack_public_path__ + "static/media/mh-4.802198ef.jpg";